export const adminRoles = {
  user: 'user',
  master: 'master',
};
